export const SPECIAL_CHARS_VALIDATION = 'specialChar';
export const SPECIAL_CHARS_VALIDATION_REGEX = /([^a-zA-Z0-9-_.~!\s*'();:@&=+$,/?%#[\]]+)/gm;
export const ValidationErrorText = {
    minDateValidation: `Date must be in the future`,
};
export const MAX_FILES_TOTAL_SIZE = 15_728_640;
